import { Grid, Typography } from '@mui/material';
import { SuccessIcon } from '@/components/common/SuccessIcon';
import React, { FC, ReactNode } from 'react';

const TEXT_WIDTH = '400px';

export const SUCCESS_MESSAGE_TITLE_ID = 'success-message-title';

interface Props {
  title: string;
  description?: string;
  icon?: ReactNode;
}

export const SuccessMessageContent: FC<Props> = (props: Props) => {
  const { title, description, icon } = props;
  return (
    <Grid container={true} direction={'column'} alignItems={'center'} rowSpacing={2} data-testid={'success-message'}>
      <Grid item={true}>{icon ?? <SuccessIcon />}</Grid>
      <Grid item={true}>
        <Typography variant={'h1'} id={SUCCESS_MESSAGE_TITLE_ID} align={'center'} sx={{ maxWidth: TEXT_WIDTH }}>
          {title}
        </Typography>
      </Grid>
      {description && (
        <Grid item={true}>
          <Typography variant={'body1'} align={'center'} sx={{ maxWidth: TEXT_WIDTH }}>
            {description}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};
